import { camelCaseKeys } from './changeCase';

export type MachineTypeId =
  | 'elite-xl'
  | 'elite'
  | 'standard'
  | 'g2.4core'
  | 'g2.6core'
  | 'g2.8core'
  | 'g2.12core'
  | 'g2-m1.8core'
  | 'g2-m1.4core'
  | 'g2-m1-max.5core'
  | 'g2-m1-max.10core'
  | 'g2-m2-pro.12core'
  | 'g2-m2-pro.6core'
  | 'g2.mac.medium'
  | 'g2.mac.large'
  | 'g2.mac.4large'
  | 'g2.mac.x-large'
  | 'g2.mac.4x-large'
  | 'g2.linux.medium'
  | 'g2.linux.2medium'
  | 'g2.linux.large'
  | 'g2.linux.4large'
  | 'g2.linux.x-large'
  | 'g2.linux.medium-plus'
  | 'g2.linux.large-plus'
  | 'g2.linux.3x-large'
  | 'g2.linux.5x-large'
  | 'g2.linux.7x-large'
  | 'g2.linux.ultra';

export const camelCaseMachineTypeData = (data: any) => {
  let availableInRegions = data.available_in_regions;

  if (Array.isArray(availableInRegions)) {
    availableInRegions = availableInRegions.map(camelCaseKeys);
  } else {
    availableInRegions = Object.fromEntries(
      Object.entries(availableInRegions).map(([regionId, regionInfo]: [string, any]) => [
        regionId,
        camelCaseKeys(regionInfo),
      ]),
    );
  }

  return {
    ...(camelCaseKeys(data) as any),
    availableInRegions,
  };
};
